<template>
    <div class="lottery_modal_container">
      <div class="home_btn" @click="backHome">
        <img :src=defultCloseIcon alt="" srcset="">
      </div>
        <div
            v-if="!loading"
            style="display: flex; justify-content: center; align-items: center;height:100vh"
        >
            <lucky-wheel v-if="!showMessageModal"
                ref="myLucky"
                :width="wheelWidth"
                :height="wheelHeight"
                :prizes="dynamicPrizes"
                :blocks="blocks"
                :buttons="buttons"
                :defaultConfig="defaultConfig"
                @start="startCallback"
                @end="endCallback"
            />

            <div class="dialog" v-if="showMessageModal">
                <div class="dialog_content">
                    <div class="dialog_alert" :style="{backgroundImage: defultWinningDialog }">
                        <div class="text">
                            {{ msg }}<br />
                            {{ msg2 }}
                        </div>

                        <div class="close_btn">
                            <span style="font-size: 16px;color: #800500;">{{ $t("turn.count") }}：{{memberCount}}</span><br />
                            <img @click="closeMessage"
                                :src=defultWinningDialogButton
                                style="width: 80px"
                            />
                        </div>
                    </div>
                </div>
            </div>

        </div>
    </div>
</template>

<script>
import bg from "../assets/hongbao/img/modal_bg1.png";

export default {
    props: {
        memberCount: {
            type: Number,
        },
        userData: {},
        awardsList: {
            type: Array,
            default: function () {
                return [];
            },
        },
        loading: {
            type: Boolean,
            default: true,
        },
        propsMsg: '',
        propsMsg2: '',
        templateSetting: '',
        templateImage: '',
        code: '',
        lang: {
          type: String,
          default: 'zh-tw'
        }
    },
    watch: {
        loading(newVal) {
            if (!newVal) {
                this.generateDynamicPrizes();
            }
        },
        templateSetting(newData, oldData) {
            this.templateSetting = newData
            this.generateDynamicPrizes();
        },
    },
    data() {
        return {
            show: false,
            msg: "",
            msg2: "",
            rolling: false,
            dynamicPrizes: [],
            blocks: [{ padding: "10px", background: "#facd89" }],
            buttons: [
                {
                    radius: "40%",
                    imgs: [
                        {
                            src: require("../assets/defult/img/go.png"),
                            top: "-140%",
                            width: '100%',
                        },
                    ],
                },
            ],
            defaultConfig: {
                gutter: "5px",
            },
            showMessageModal : false,
            windowWidth: 500,
            windowHeight: 500,
            defultFontColor: "#FFFFFF",
            defultColor1: "#7d0000",
            defultColor2: "#b52618",
            defultColorBorder : "#facd89",
            defultCloseIcon: require("../assets/defult/img/closebtn.png"),
            defultWinningDialogButton: require('../assets/hongbao/img/comfirBtnGa' + this.lang + '.png'),
            defultWinningDialog: `url(${bg})`,
        };
        
    },
    mounted() {
        if (!this.loading) {
            this.generateDynamicPrizes();
        }
        //以下新增
        this.windowWidth = window.innerWidth;
        window.addEventListener("resize", this.handleResize);
    },
    computed: {
        wheelWidth() {
            return document.body.clientWidth < 768 ? "330px" : "500px";
        },
        wheelHeight() {
            return document.body.clientWidth < 768 ? "330px" : "500px";
        },
        fontSizes() {
            return document.body.clientWidth < 768 ? 25 : 35;
        },
    },
    methods: {
        handleResize() {
            this.windowWidth = document.body.clientWidth;
            this.$refs.myLucky.init();
        },
        generateDynamicPrizes() {

            if (this.templateSetting != '') {
                const json_setting = JSON.parse(this.templateSetting)
                let FontColor  = json_setting[0].FontColor
                let Color1 = json_setting[0].Color1
                let Color2 = json_setting[0].Color2
                let ColorBorder = json_setting[0].ColorBorder
                this.defultFontColor = FontColor != '' ? FontColor : this.defultFontColor
                this.defultColor1 = Color1 != '' ? Color1 : this.defultColor1
                this.defultColor2 = Color2 != '' ? Color2 : this.defultColor2
                this.blocks[0].background = ColorBorder != ''? ColorBorder : this.defultColorBorder
            }
            if (this.templateImage != '') {
                const json_image = JSON.parse(this.templateImage)
                console.log(json_image)
                for (const [key, value] of Object.entries(json_image)) {
                    switch (key) {
                        case "CloseIcon":
                            this.defultCloseIcon = value
                            break;
                        case "LotteryButton":
                            this.buttons[0].imgs[0].src = value
                            break;
                        case "WinningDialog":
                            this.defultWinningDialog = `url(${value})`
                            break;
                        case "WinningDialogButton":
                            this.defultWinningDialogButton = value
                            break;
                            
                        default:
                            break;
                    }
                }
            }

            this.dynamicPrizes = []
            for (let index = 0; index < this.awardsList.length; index++) {
                const element = this.awardsList[index];
                this.dynamicPrizes.push({
                    fonts: [
                        {
                            text: element,
                            top: "10%",
                            fontSize: this.fontSizes,
                            fontColor: this.defultFontColor,
                        },
                    ],

                    background: index % 2 === 0 ? this.defultColor1 : this.defultColor2,
                });
            }
        },
        startCallback() {
          if (this.code != "0") {
            this.showMessageModal = true
            this.msg = this.propsMsg
            this.msg2 = this.propsMsg2
          } else {
            //如果次數為0 不得抽獎
            if (this.memberCount === 0 || this.memberCount === null) {
              this.msg = this.$t("turn.zero");
              this.msg2 = "";
              // 如果尚在抽獎中不執行任何動作
            } else {
              if (this.rolling) {
                this.msg = this.$t("turn.drawing");
                this.msg2 = "";
                return;
              }
              this.getWinning();
            }
          }
        },
        // 点击抽奖按钮会触发star回调
        async getWinning() {
            let result = 0;
            // 调用抽奖组件的play方法开始游戏
            this.$refs.myLucky.play();

            this.rolling = true;
            let postData = {
                Token: this.userData.token,
                PEid: this.userData.peid,
            };
            await fetch("/api/drawEvents", {
                method: "POST",
                body: JSON.stringify(postData),
            })
                .then((res) => res.json())
                .then((res) => {
                    if (res.code == "0") {
                        let jresult = JSON.parse(res.data);
                        result = Object.keys(jresult);
                    } else {
                      this.showMessageModal = true
                      this.msg = this.$t('turn.' + res.data)
                      this.msg2 = this.$t("turn.contact");
                    }
                    this.rolling = false;

                });
            // 模拟调用接口异步抽奖
            setTimeout(() => {
                // 假设后端返回的中奖索引是0
                // const index = 1
                // 调用stop停止旋转并传递中奖索引
                this.$refs.myLucky.stop(result);
            }, 3000);
        },
        // 抽奖结束会触发end回调
        endCallback(prize) {
            this.showMessageModal = true;
            this.msg = this.$t("turn.congratulations");
            this.msg2 = prize.fonts[0].text;
            this.$emit("rollDone", 1);
        },
        closeMessage() {
          this.$emit('closeDialog', false)
          this.showMessageModal = false;
        },
        backHome() {
          this.$emit('closeDialog', false)
        }
    },
};
</script>


<style scoped>
@import "../assets/hongbao/css/style.css";
@import "../assets/hongbao/css/animate.css";
@import "../assets/hongbao/css/bootstrap.css";
</style>



// WEBPACK FOOTER //
// src/components/turntable_modal1.vue